const initialState = {
  id: window.localStorage.getItem("userId"),
  totalSpent: null,
  availableCredit: null,
  amountDue: null,
  remainingStatementBalance: null,
  transactionHistory: [],
  paymentMethods: [],
  defaultPaymentMethod: 0,
  paymentHistory: [],
  nextPayment: "",
  jwt: null,
  roles: {},
};

export default function user(state = initialState, { type, payload }) {
  switch (type) {
  case "SET_JWT":
    return { ...state, jwt: payload.jwt };
  case "SET_USER_ID":
    return { ...state, id: payload.id };
  case "SET_ROLES":
    return { ...state, roles: payload.roles };
  default:
    return state;
  }
}
